import { useCallback } from "react";

import { useAppSelector } from "../../../../hooks";
import { selectCurrentUser } from "../../../authentication/services";
import { KIOSK_TAB_FEATURE_FLAGS } from "../constants/kioskFeatureFlags";
import { KioskViewId } from "../types/types";

export const useKioskTabAccess = () => {
    const currentUser = useAppSelector(selectCurrentUser);
    const isAdmin = currentUser?.role === "admin" || currentUser?.role === "root";

    /** Hidden entirely — adminOnly tabs are invisible to non-admin users */
    const isTabVisible = useCallback(
        (tabId: KioskViewId): boolean => {
            const flag = KIOSK_TAB_FEATURE_FLAGS[tabId];
            if (flag.adminOnly && !isAdmin) return false;
            return true;
        },
        [isAdmin]
    );

    /** Grayed-out — tab is visible but not clickable when enabled=false */
    const isTabEnabled = useCallback(
        (tabId: KioskViewId): boolean => {
            const flag = KIOSK_TAB_FEATURE_FLAGS[tabId];
            return flag.enabled && isTabVisible(tabId);
        },
        [isTabVisible]
    );

    return { isTabVisible, isTabEnabled };
};
